import { render, staticRenderFns } from "./deleteProductDialog.vue?vue&type=template&id=e2ce4fd0&"
import script from "./deleteProductDialog.vue?vue&type=script&lang=js&"
export * from "./deleteProductDialog.vue?vue&type=script&lang=js&"
import style0 from "./deleteProductDialog.vue?vue&type=style&index=0&id=e2ce4fd0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports